import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">McMahon · Your Trusted Partner</p>
        <h1>Welcome to McMahon.</h1>
        <p className="lede">
          Discover a world of quality and reliability with McMahon. We are dedicated to providing exceptional products and services tailored to meet your needs.
        </p>
        <div className="cta-row">
          <a href="/products" target="_self">
            Explore Our Products
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Quality You Can Trust</h2>
          <p>
            At McMahon, we prioritize quality in every product we offer, ensuring that you receive only the best.
          </p>
        </article>
        <article>
          <h2>Exceptional Customer Service</h2>
          <p>
            Our team is here to assist you at every step, providing personalized support to enhance your experience.
          </p>
        </article>
        <article>
          <h2>Innovative Solutions</h2>
          <p>
            We continuously strive to bring you innovative solutions that meet the evolving demands of our customers.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;